import styled from "styled-components";
export const ChatLeftStyle = styled.div`
  width: 50%;
  margin-bottom: 5px;
  direction: ltr;
  margin-right: auto;
  .user {
    padding: 5px 0px;
    img {
      background-color: #f0f0f0;
      width: 30px;
      height: 30px;
      border: none;
    }
  }
  .text {
    width: fit-content;
    max-width: 100%;
    word-wrap: break-word;
    padding: 10px 20px;
    background-color: ${({ theme }) => theme.chatLeft};
    border-radius: 10px;
    p {
      position: relative;
    }
  }
  .link {
    color: ${({ theme }) => theme.text} !important;
    font-size: 12px;
    cursor: pointer;
  }
`;
